export const arrayUniqueValues = <ArrayType = unknown>(array: ArrayType[]): ArrayType[] => Array.from(new Set(array))
